import React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { CircularProgress, Typography, Grid } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'

interface ConfirmMobileProps {
  open: boolean
  handleClose: () => void
  onClick: () => void
  confirmTitle: string
  confirmText: string
  negateText: string
  backdropClick?: boolean
  disabled?: boolean
  hideBackdrop?: boolean
  btnCloseModal?: boolean
  isLoading?: boolean
  confirmHeaderText?: string
}

export const ConfirmMobile: React.FC<ConfirmMobileProps> = ({
  open,
  handleClose,
  onClick,
  confirmTitle,
  confirmText,
  negateText,
  isLoading,
  confirmHeaderText,
  disabled
}) => {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='draggable-dialog-title'
      >
        <DialogTitle id='draggable-dialog-title'>
          <Grid
            container
            direction='row'
            justifyContent='flex-end'
            alignItems='center'
            style={{ height: '50px', maxHeight: '50px', minHeight: '50px' }}
          >
            <IconButton
              color='primary'
              onClick={handleClose}
              disabled={disabled}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
          <Typography variant='h4' style={{ fontWeight: 'bold' }}>
            {confirmHeaderText}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant='h6'>{confirmTitle}</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            display: 'inline-flex',
            padding: '15px',
            flex: '0 0 auto',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Button
            variant='contained'
            color='secondary'
            style={{ marginLeft: 16 }}
            onClick={handleClose}
            disabled={isLoading}
          >
            {negateText}
          </Button>
          <Button
            variant='contained'
            color='primary'
            style={{ marginLeft: 16 }}
            onClick={onClick}
            startIcon={
              isLoading ? <CircularProgress size='0.9rem' /> : undefined
            }
            disabled={isLoading}
          >
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
